import { PrismicRichText } from "@prismicio/react";
import React from 'react';

export const Quote = (props) => {

    const sc = props.slice.primary;

    let space = sc.spacing;

    if (space === "Both large") {
        space = "gutter";
    } else if (space === "Both small") {
        space = "gutter sm";
    } else if (space === "Top large") {
        space = "gutter bot";
    } else if (space === "Top small") {
        space = "gutter bot sm";
    } else if (space === "Bottom large") {
        space = "gutter top";
    } else {
        space = "gutter top sm";
    }

    let bg = sc.background === "gradient" ? "gradient-to-b from-grey-light to-white" : sc.background === "grey" ? "grey-light" : sc.background;

    let boxbg = sc.box_background === "gradient" ? "gradient-to-b from-grey-light to-white" : sc.box_background === "grey" ? "grey-light" : sc.box_background;

    const components = {
        label: ({ children }) => (
          <sup>{children}</sup>
        ),
    }


    return (
        <section className={"textblock bg-" + (bg) + " " + (sc.theme) + " " + (space)}>
            <div className="wrapper md:mb-8">
                <div className={"w-auto text-center m-auto p-6 md:p-16 rounded-lg md:rounded-2xl md:w-3/4 bg-" + (boxbg) + ' ' + (sc.theme)}>
                <div className={"quotey mb-2 md:mb-8 text-" + sc.theme}><i className="fa-solid fa-quote-left text-4xl md:text-6xl"></i></div>
                <div className={"text-base md:text-xl mb-8 text-" + (sc.text_color)}><PrismicRichText field={sc.quote.richText} components={components} /></div>
                <span className={"text-" + (sc.text_color)}><strong className="md:text-lg">{sc.author}</strong><br />{sc.author_meta}</span>
                </div>
                
            </div>
        </section>
    );
}

